import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import * as util from '../../library/utilitys'; // adjust path as needed

class DashboardInfoSummaryBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animatedValue: null
        };
        this.interval = null;
    }

    componentDidMount() {
        this.animateValue();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.animateValue();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    animateValue() {
        clearInterval(this.interval);

        const { value } = this.props;
        const targetValue = parseFloat(value) || 0;
        const duration = 1000;
        const steps = 30;
        const stepTime = duration / steps;
        let currentStep = 0;

        this.interval = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;
            const animatedValue = Math.round(targetValue * progress);
            this.setState({ animatedValue });

            if (currentStep >= steps) {
                clearInterval(this.interval);
                this.setState({ animatedValue: Math.round(targetValue) });
            }
        }, stepTime);
    }

    render() {
        const { infoLabel, number, variant = 'primary', value } = this.props;
        const { animatedValue } = this.state;

        return (
            <div>
                <span className="d-block fw-medium fs-7">{infoLabel}</span>
                <div className="d-flex align-items-center">
                    <span className="d-block fs-4 fw-medium text-dark mb-0">{number}</span>
                    {(value && animatedValue !== null) && (
                        <Badge bg={variant} className="ms-2">
                            {util.formatNumber(animatedValue, true)}
                        </Badge>
                    )}
                </div>
            </div>
        );
    }
}

export default DashboardInfoSummaryBox;
